import { createContext } from 'react';

export const ParamsCtx = createContext(null);
